@if (!embedMode) {
  
}

<main
  [ngClass]="
    embedMode
      ? 'flex flex-col font-sans flex-1 min-h-0 overflow-hidden'
      : 'min-h-[calc(100vh-80px)] bg-white flex flex-col font-sans'
  "
  [class.knowledge-setup--embed]="embedMode"
  role="main">
  @if (embedMode) {
    <div class="knowledge-embed-backbar flex shrink-0 align-items-center">
      <button
        type="button"
        class="btn btn-link btn-sm text-decoration-none p-2 ps-0 fw-semibold"
        (click)="onEmbedBack()">
        {{ 'voiceAssistant.backToAssistant' | translate }}
      </button>
    </div>
  }

  <div
    [ngClass]="
      embedMode
        ? 'flex flex-col flex-1 w-full min-h-0 overflow-hidden'
        : 'flex flex-col md:flex-row flex-1 w-full'
    ">
    <!-- LEFT PANEL: FORM CONFIGURATION -->
    <aside
      [ngClass]="
        embedMode
          ? 'p-3 flex flex-col z-10 shrink-0'
          : 'bg-white/80 backdrop-blur-xl p-6 md:p-8 border-b md:border-b-0 md:border-r border-slate-200 flex flex-col md:w-[35%] md:h-[calc(100vh-80px)] md:sticky md:top-0 overflow-y-auto z-10 scrollbar-hidden'
      ">
      <header [ngClass]="embedMode ? 'mb-3' : 'mb-8'">
        <h1
          [ngClass]="
            embedMode
              ? 'h5 mb-1 fw-semibold knowledge-embed-title'
              : 'text-3xl font-bold text-blue-900 mb-2 leading-tight'
          ">
          {{ 'knowledgeSetup.title' | translate }}
        </h1>
        <p
          [ngClass]="
            embedMode ? 'small text-muted mb-0' : 'text-base text-slate-500 m-0'
          ">
          {{ 'knowledgeSetup.subtitle' | translate }}
        </p>
      </header>

      <div [ngClass]="embedMode ? 'mb-3' : 'mb-6'">
        <label
          [ngClass]="
            embedMode
              ? 'form-label small fw-semibold mb-1 text-secondary'
              : 'block font-semibold text-sm text-slate-700 mb-2'
          "
          >{{ 'knowledgeSetup.domain' | translate }}</label
        >
        @if (embedMode) {
          <div
            class="w-100"
            ngbDropdown
            container="body"
            dropdownClass="knowledge-embed-dropdown"
            placement="bottom-start">
            <button
              type="button"
              class="btn w-100 text-start d-flex align-items-center justify-content-between gap-2 knowledge-embed-control"
              ngbDropdownToggle>
              <span class="text-truncate flex-grow-1">
                @if (selectedDomain) {
                  {{ selectedDomain.name }}
                } @else {
                  {{ 'knowledgeSetup.selectDomain' | translate }}
                }
              </span>
            </button>
            <div ngbDropdownMenu class="dropdown-menu py-0 knowledge-embed-dropdown-menu">
              <button type="button" ngbDropdownItem (click)="pickEmbedDomain(null)">
                {{ 'knowledgeSetup.selectDomain' | translate }}
              </button>
              @for (domain of domains; track domain.id) {
                <button type="button" ngbDropdownItem (click)="pickEmbedDomain(domain)">
                  {{ domain.name }}
                </button>
              }
            </div>
          </div>
        } @else {
          <select
            class="w-full px-4 py-3 text-base rounded-xl border border-slate-200 bg-white/90 text-slate-800 transition-all focus:outline-none focus:border-blue-500 focus:ring-4 focus:ring-blue-500/15"
            [(ngModel)]="selectedDomain"
            (change)="onDomainChange()">
            <option [ngValue]="null">{{ 'knowledgeSetup.selectDomain' | translate }}</option>
            @for (domain of domains; track domain.id) {
              <option [ngValue]="domain">{{ domain.name }}</option>
            }
          </select>
        }
      </div>

      @if (selectedDomain) {
        <div [ngClass]="embedMode ? 'mb-3' : 'mb-6'">
          <label
            [ngClass]="
              embedMode
                ? 'form-label small fw-semibold mb-1 text-secondary'
                : 'block font-semibold text-sm text-slate-700 mb-2'
            "
            >{{ 'knowledgeSetup.question' | translate }}</label
          >
          @if (isLoadingQuestions) {
            <div
              [ngClass]="
                embedMode ? 'small text-muted animate-pulse' : 'text-sm text-slate-500 animate-pulse'
              ">
              {{ 'knowledgeSetup.loadingQuestions' | translate }}
            </div>
          } @else {
            @if (embedMode) {
              <div
                class="w-100"
                ngbDropdown
                container="body"
                dropdownClass="knowledge-embed-dropdown"
                placement="bottom-start">
                <button
                  type="button"
                  class="btn w-100 text-start d-flex align-items-center justify-content-between gap-2 knowledge-embed-control"
                  ngbDropdownToggle>
                  <span class="text-truncate flex-grow-1">
                    @if (selectedQuestion) {
                      {{ selectedQuestion.content }}
                    } @else {
                      {{ 'knowledgeSetup.selectQuestion' | translate }}
                    }
                  </span>
                </button>
                <div ngbDropdownMenu class="dropdown-menu py-0 knowledge-embed-dropdown-menu">
                  <button type="button" ngbDropdownItem (click)="pickEmbedQuestion(null)">
                    {{ 'knowledgeSetup.selectQuestion' | translate }}
                  </button>
                  @for (question of questions; track question.id) {
                    <button type="button" ngbDropdownItem (click)="pickEmbedQuestion(question)">
                      {{ question.content }}
                    </button>
                  }
                </div>
              </div>
            } @else {
              <select
                class="w-full px-4 py-3 text-base rounded-xl border border-slate-200 bg-white/90 text-slate-800 transition-all focus:outline-none focus:border-blue-500 focus:ring-4 focus:ring-blue-500/15"
                [(ngModel)]="selectedQuestion">
                <option [ngValue]="null">{{ 'knowledgeSetup.selectQuestion' | translate }}</option>
                @for (question of questions; track question.id) {
                  <option [ngValue]="question">{{ question.content }}</option>
                }
              </select>
            }
          }
        </div>
      }

      <div [ngClass]="embedMode ? 'mb-3' : 'mb-6'">
        <label
          [ngClass]="
            embedMode
              ? 'form-label small fw-semibold mb-1 text-secondary'
              : 'block font-semibold text-sm text-slate-700 mb-2'
          "
          >{{ 'knowledgeSetup.selectPedagogy' | translate }}</label
        >
        @if (embedMode) {
          <div
            class="w-100"
            ngbDropdown
            container="body"
            dropdownClass="knowledge-embed-dropdown"
            placement="bottom-start">
            <button
              type="button"
              class="btn w-100 text-start d-flex align-items-center justify-content-between gap-2 knowledge-embed-control"
              ngbDropdownToggle>
              <span class="text-truncate flex-grow-1">
                @if (selectedPedagogy) {
                  {{ selectedPedagogy }}
                } @else {
                  {{ 'knowledgeSetup.selectPedagogyOption' | translate }}
                }
              </span>
            </button>
            <div ngbDropdownMenu class="dropdown-menu py-0 knowledge-embed-dropdown-menu">
              <button type="button" ngbDropdownItem (click)="pickEmbedPedagogy(null)">
                {{ 'knowledgeSetup.selectPedagogyOption' | translate }}
              </button>
              @for (pedagogy of pedagogies; track pedagogy) {
                <button type="button" ngbDropdownItem (click)="pickEmbedPedagogy(pedagogy)">
                  {{ pedagogy }}
                </button>
              }
            </div>
          </div>
        } @else {
          <select
            class="w-full px-4 py-3 text-base rounded-xl border border-slate-200 bg-white/90 text-slate-800 transition-all focus:outline-none focus:border-blue-500 focus:ring-4 focus:ring-blue-500/15"
            [(ngModel)]="selectedPedagogy">
            <option [ngValue]="null">{{ 'knowledgeSetup.selectPedagogyOption' | translate }}</option>
            @for (pedagogy of pedagogies; track pedagogy) {
              <option [value]="pedagogy">{{ pedagogy }}</option>
            }
          </select>
        }
      </div>

      <div [ngClass]="embedMode ? 'row g-2 mb-3' : 'grid grid-cols-2 gap-4 mb-6'">
        <div [ngClass]="embedMode ? 'col-6' : ''">
          <label
            [ngClass]="
              embedMode
                ? 'form-label small fw-semibold mb-1 text-secondary'
                : 'block font-semibold text-sm text-slate-700 mb-2'
            "
            >{{ 'knowledgeSetup.selectCountry' | translate }}</label
          >
          @if (embedMode) {
            <div
              class="w-100"
              ngbDropdown
              container="body"
              dropdownClass="knowledge-embed-dropdown"
              placement="bottom-start">
              <button
                type="button"
                class="btn w-100 text-start d-flex align-items-center justify-content-between gap-2 knowledge-embed-control"
                ngbDropdownToggle>
                <span class="text-truncate flex-grow-1">{{ embedSelectedCountryLabel() }}</span>
              </button>
              <div ngbDropdownMenu class="dropdown-menu py-0 knowledge-embed-dropdown-menu">
                @for (country of countries; track country.value) {
                  <button type="button" ngbDropdownItem (click)="pickEmbedCountry(country.value)">
                    {{ country.label }}
                  </button>
                }
              </div>
            </div>
          } @else {
            <select
              class="w-full px-4 py-3 text-base rounded-xl border border-slate-200 bg-white/90 text-slate-800 transition-all focus:outline-none focus:border-blue-500 focus:ring-4 focus:ring-blue-500/15"
              [(ngModel)]="selectedCountry">
              @for (country of countries; track country.value) {
                <option [value]="country.value">{{ country.label }}</option>
              }
            </select>
          }
        </div>

        <div [ngClass]="embedMode ? 'col-6' : ''">
          <label
            [ngClass]="
              embedMode
                ? 'form-label small fw-semibold mb-1 text-secondary'
                : 'block font-semibold text-sm text-slate-700 mb-2'
            "
            >{{ 'knowledgeSetup.standardLevel' | translate }}</label
          >
          @if (embedMode) {
            <div
              class="w-100"
              ngbDropdown
              container="body"
              dropdownClass="knowledge-embed-dropdown"
              placement="bottom-start">
              <button
                type="button"
                class="btn w-100 text-start d-flex align-items-center justify-content-between gap-2 knowledge-embed-control"
                ngbDropdownToggle>
                <span class="text-truncate flex-grow-1">{{ selectedLevel }}</span>
              </button>
              <div ngbDropdownMenu class="dropdown-menu py-0 knowledge-embed-dropdown-menu">
                @for (level of levels; track level) {
                  <button type="button" ngbDropdownItem (click)="pickEmbedLevel(level)">
                    {{ level }}
                  </button>
                }
              </div>
            </div>
          } @else {
            <select
              class="w-full px-4 py-3 text-base rounded-xl border border-slate-200 bg-white/90 text-slate-800 transition-all focus:outline-none focus:border-blue-500 focus:ring-4 focus:ring-blue-500/15"
              [(ngModel)]="selectedLevel">
              @for (level of levels; track level) {
                <option [value]="level">{{ level }}</option>
              }
            </select>
          }
        </div>
      </div>

      <button
        type="button"
        [ngClass]="
          embedMode
            ? 'btn btn-primary w-100 mt-2 knowledge-embed-generate'
            : 'w-full mt-4 p-4 rounded-xl bg-gradient-to-br from-blue-500 to-blue-600 text-white font-semibold text-lg shadow-[0_4px_14px_rgba(37,99,235,0.3)] transition-all hover:-translate-y-0.5 hover:shadow-[0_6px_20px_rgba(37,99,235,0.4)] disabled:bg-slate-200 disabled:text-slate-400 disabled:shadow-none disabled:cursor-not-allowed disabled:transform-none'
        "
        [disabled]="!isFormValid()"
        (click)="generatePrompt()">
        <span>
          {{ 'knowledgeSetup.generate' | translate }} {{ 'virtualAssistant.artifacts.' + artifact | translate }}
        </span>
      </button>

      <button
        type="button"
        [ngClass]="
          embedMode
            ? 'btn w-100 mt-2 d-inline-flex align-items-center justify-content-center gap-2 knowledge-embed-secondary'
            : 'w-full mt-4 p-4 rounded-xl border border-slate-200 bg-transparent text-slate-500 font-semibold flex items-center justify-center transition-all hover:bg-slate-50 hover:text-slate-800 hover:border-slate-300'
        "
        (click)="toggleHistory()">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="flex-shrink-0" [class.me-2]="!embedMode"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
        <span>{{ showHistory ? 'Close History' : ('knowledgeSetup.viewHistory' | translate) }}</span>
      </button>
    </aside>

    <!-- RIGHT PANEL: RESULTS & HISTORY -->
    <section
      class="results-panel flex-1 bg-white flex-col"
      [ngClass]="
        embedMode
          ? 'flex p-4 min-h-0 flex-1 overflow-y-auto scrollbar-hidden'
          : 'p-6 md:p-8 md:h-[calc(100vh-80px)] md:overflow-y-auto scrollbar-hidden ' + resultsSectionDisplayClass()
      ">
      <!-- History View -->
      @if (showHistory) {
        <div>
          @if (isLoadingHistory) {
            <div class="m-auto flex flex-col items-center justify-center pt-20">
              <div class="w-12 h-12 border-4 border-blue-500/20 border-t-blue-500 rounded-full animate-spin mb-4"></div>
              <p class="text-slate-500">{{ 'knowledgeSetup.loadingHistory' | translate }}</p>
            </div>
          } @else if (historyList.length === 0) {
            <div class="m-auto text-center flex flex-col items-center justify-center pt-20">
              <p class="text-slate-500">{{ 'knowledgeSetup.noHistory' | translate }}</p>
            </div>
          } @else {
            <div class="grid grid-cols-1 md:grid-cols-[repeat(auto-fill,minmax(280px,1fr))] gap-6 w-full">
              @for (item of historyList; track item.id) {
                <article class="bg-white rounded-2xl p-6 shadow-[0_10px_40px_rgba(0,0,0,0.04)] border border-slate-100 flex flex-col transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_15px_45px_rgba(0,0,0,0.06)] cursor-pointer" (click)="viewHistoryItem(item.id)">
                  <h3 class="text-xl font-bold text-blue-900 mb-2">{{ item.title || item.topic }}</h3>
                  <p class="text-sm text-slate-500 mb-1">{{ item.created_at | date: 'medium' }}</p>
                  <p class="text-sm text-slate-500">
                    @if (item.content_type || item.artifact) {
                      <span class="me-2 font-medium text-slate-600">{{ item.content_type || item.artifact }}</span>
                    }
                    {{ item.pedagogy }}
                  </p>
                </article>
              }
            </div>
          }
        </div>
      }
      <!-- Loading Generation -->
      @else if (genratingResponse) {
        <div class="m-auto flex flex-col items-center justify-center pt-20">
          <div class="w-12 h-12 border-4 border-blue-500/20 border-t-blue-500 rounded-full animate-spin mb-4"></div>
          <p class="text-slate-500">
            {{ 'knowledgeSetup.generatingContent' | translate }}
            <strong class="text-slate-800">{{ 'virtualAssistant.artifacts.' + artifact | translate }}</strong>...
          </p>
        </div>
      }
      <!-- Structured API result (generate-educational-content) -->
      @else if (generatedView) {
        <app-educational-content-view
          [view]="generatedView"
          [embedMode]="embedMode"
          [artifactKey]="artifact" />
      }
      <!-- Legacy: suggestions[] shape -->
      @else if (finalFormat) {
        <div class="flex flex-col w-full">
          @for (suggestion of finalFormat.suggestions; track $index) {
            <article class="flex flex-col">
              <h2 class="text-2xl lg:text-3xl font-bold text-blue-900 mb-4 leading-snug">{{ suggestion.title }}</h2>

              <div class="flex flex-wrap gap-4 mb-6 pb-6 border-b border-slate-100">
                <span class="inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-semibold bg-blue-50 text-blue-600">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                  {{ suggestion.concept }}
                </span>
                <span class="inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-semibold bg-emerald-50 text-emerald-600">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
                  {{ suggestion.ageAppropriate }}
                </span>
              </div>

              <div class="bg-gradient-to-br from-white to-slate-50 p-6 lg:p-8 rounded-2xl my-6 border border-blue-500/15 border-l-4 border-l-blue-500 flex-1 relative shadow-[0_4px_15px_rgba(59,130,246,0.05)] overflow-hidden group">
                <div class="absolute -top-4 -right-2 text-9xl font-serif text-blue-500/5 leading-none select-none pointer-events-none group-hover:text-blue-500/10 transition-colors">"</div>
                <div class="mb-4 relative z-10">
                  <span class="inline-block bg-blue-500 text-white px-3 py-1 rounded-md text-xs font-bold tracking-wide uppercase">{{ suggestion.content.type | titlecase }}</span>
                </div>
                <p class="leading-relaxed whitespace-pre-wrap text-slate-700 text-lg m-0 relative z-10">{{ formatSteps(suggestion.content.value) }}</p>
              </div>

              <div class="grid grid-cols-1 md:grid-cols-2 gap-5 mt-auto border-t border-dashed border-slate-200 pt-6">
                <div class="bg-slate-50 border border-slate-100 p-6 rounded-xl transition-all hover:bg-slate-100 hover:border-blue-500/20">
                  <div class="flex items-center gap-3 mb-3">
                    <div class="flex items-center justify-center w-8 h-8 rounded-lg bg-amber-50 text-amber-600">
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 2 7 12 12 22 7 12 2"></polygon><polyline points="2 17 12 22 22 17"></polyline><polyline points="2 12 17 22 12"></polyline></svg>
                    </div>
                    <h3 class="font-bold text-slate-800 m-0 text-base">{{ 'knowledgeSetup.materialsNeeded' | translate }}</h3>
                  </div>
                  <ul class="m-0 pl-5 text-sm text-slate-600 list-disc">
                    @for (item of suggestion.materialsNeeded; track item) {
                      <li class="mb-1">{{ item }}</li>
                    }
                  </ul>
                </div>

                <div class="bg-slate-50 border border-slate-100 p-6 rounded-xl transition-all hover:bg-slate-100 hover:border-blue-500/20">
                  <div class="flex items-center gap-3 mb-3">
                    <div class="flex items-center justify-center w-8 h-8 rounded-lg bg-violet-50 text-violet-600">
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="7.5 4.21 12 6.81 16.5 4.21"></polyline><polyline points="7.5 19.79 7.5 14.6 3 12"></polyline><polyline points="21 12 16.5 14.6 16.5 19.79"></polyline><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line></svg>
                    </div>
                    <h3 class="font-bold text-slate-800 m-0 text-base">{{ 'knowledgeSetup.adaptability' | translate }}</h3>
                  </div>
                  <p class="text-sm text-slate-600 leading-relaxed m-0">{{ suggestion.adaptability }}</p>
                </div>

                <div class="bg-slate-50 border border-slate-100 p-6 rounded-xl transition-all hover:bg-slate-100 hover:border-blue-500/20">
                  <div class="flex items-center gap-3 mb-3">
                    <div class="flex items-center justify-center w-8 h-8 rounded-lg bg-blue-50 text-blue-600">
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path></svg>
                    </div>
                    <h3 class="font-bold text-slate-800 m-0 text-base">{{ 'knowledgeSetup.pedagogyIntegration' | translate }}</h3>
                  </div>
                  <p class="text-sm text-slate-600 leading-relaxed m-0">{{ suggestion.pedagogyIntegration }}</p>
                </div>

                <div class="bg-slate-50 border border-slate-100 p-6 rounded-xl transition-all hover:bg-slate-100 hover:border-blue-500/20">
                  <div class="flex items-center gap-3 mb-3">
                    <div class="flex items-center justify-center w-8 h-8 rounded-lg bg-pink-50 text-pink-600">
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>
                    </div>
                    <h3 class="font-bold text-slate-800 m-0 text-base">{{ 'knowledgeSetup.inclusivity' | translate }}</h3>
                  </div>
                  <p class="text-sm text-slate-600 leading-relaxed m-0">{{ suggestion.inclusivityNotes }}</p>
                </div>
              </div>
            </article>
          }
        </div>
      }
      <!-- Empty State -->
      @else {
        <div
          class="m-auto text-center flex flex-col items-center justify-center"
          [ngClass]="embedMode ? 'pt-8' : 'pt-20'">
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" [ngClass]="embedMode ? 'text-muted mb-3' : 'text-slate-400 mb-4'"><circle cx="12" cy="12" r="10"></circle><polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"></polygon></svg>
          <h2 [ngClass]="embedMode ? 'h6 mb-1 fw-semibold text-body m-0' : 'm-0 text-2xl text-slate-700 font-bold'">
            {{ 'knowledgeSetup.ready' | translate }}
          </h2>
          <p [ngClass]="embedMode ? 'small text-muted mb-0 px-2' : 'mt-2 text-slate-500'">
            {{ 'knowledgeSetup.readySubtitle' | translate }}
          </p>
        </div>
      }
    </section>
  </div>
</main>
